import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import Title from "features/goalPlan/views/shared/title";
import SubTitle from "features/goalPlan/views/shared/subtitle";
import { BannerAlert } from "features/shared/components";
import { t } from "adapters/i18n";

const TEXT_TITLE = t("goalPlan:goal-registration");
const TEXT_SUBTITLE = t("goalPlan:goal-registration-info");

const GoalsHeader = ({
  classes,
  title = TEXT_TITLE,
  subtitle = TEXT_SUBTITLE,
  alertOptions,
}) => {
  const TitleComponent =
    typeof title === "string"
      ? () => (
          <Title
            style={{
              fontWeight: 500,
            }}
          >
            {title}
          </Title>
        )
      : title;
  const SubTitileComponent =
    typeof subtitle === "string"
      ? () => (
          <SubTitle
            style={{
              marginTop: "16px",
            }}
          >
            {subtitle}
          </SubTitle>
        )
      : subtitle;

  return (
    <Grid container direction="column" className={classes.titleContainer}>
      <TitleComponent />
      <SubTitileComponent />
      {alertOptions && (
        <BannerAlert
          className={classes.alert}
          data-testid="Form-Alert"
          type={alertOptions.type}
          customIcon={alertOptions.icon}
        >
          {alertOptions.message}
        </BannerAlert>
      )}
    </Grid>
  );
};

const styles = (theme) => ({
  titleContainer: {
    marginTop: theme.telas.marginTopTitulo,
  },
  alert: {
    marginTop: "24px",
  },
});

export default withStyles(styles)(GoalsHeader);
